// Roles

const ROLES_NAME = {
  Admin: "Admin",
  ClinicAdmin: "Clinic Admin",
  CU: "Clinic User",
  Doc: "Doctor",
  Physician: "Physician",
  PU: "Power User",
  RDU: "Radiologist User",
  RefDoc: "Referring Doctor",
  SDD: "Shared Doctor",
  SDP: "Shared Patient",
  SuperAdmin: "Super Admin",
  TCU: "Technician User"
}

export default ROLES_NAME